import React from 'react';
import Repeater from '@components/repeater';
import { Row, FormGroup, Button } from 'reactstrap';
import { PlusCircle, Trash } from 'react-feather';
import { Flex } from '@chakra-ui/react';
import ActionButton from '../ActionButton';
import RepeaterControlled from './RepeaterControlled';
import ElementRepeated from './ElementRepeated';

const FormRepeater = ({
	caption,
	value,
	first = {
		caption: 'Nombre',
		name: 'name'
	},
	second = {
		caption: 'Valor',
		name: 'value'
	},
	onChange
}) => {
	const handleChange = (element_name, element_value, element_index) => {
		value[element_index][element_name] = element_value;
		onChange({ value });
	};

	const increaseCount = () => {
		value.push({
			[first.name]: '',
			[second.name]: ''
		});
		onChange({ value });
	};

	const deleteForm = (i) => {
		const v = [...value];
		v.splice(i, 1);
		onChange({ value: v });
	};

	return (
		<>
			<Repeater count={value?.length}>
				{(i) => (
					<Flex key={i} alignItems={'end'} gap={10}>
						<ElementRepeated
							i={i}
							first={first}
							second={second}
							values={value}
							onChange={handleChange}
						/>
						<FormGroup style={{ marginBottom: '1.3rem', width: '10%' }}>
							{/*<ActionButton*/}
							{/*	size={'25px'}*/}
							{/*	id={`deleteElementAction-${i}`}*/}
							{/*	hoverColor={'red'}*/}
							{/*	icon={<PenTool size={20} />}*/}
							{/*	onClick={() => deleteForm(i)}*/}
							{/*/>*/}
							<ActionButton
								size={'25px'}
								id={`deleteElementAction-${i}`}
								hoverColor={'red'}
								icon={<Trash size={20} />}
								onClick={() => deleteForm(i)}
							/>
						</FormGroup>
					</Flex>
				)}
			</Repeater>
			<Row className="d-flex justify-content  m-0 my-2 ">
				<Button
					className="header-row-button "
					color="primary"
					onClick={increaseCount}
				>
					<PlusCircle />
					<span className="mx-auto font-medium-1">
						{caption || 'Agregar elemento'}
					</span>
				</Button>
			</Row>
		</>
	);
};

export { RepeaterControlled as FormRepeater2 };

export default FormRepeater;
